export const Astyle = {
    textDecoration: "none", 
    color: "black" 
}